import React, { useState, useEffect } from 'react';
import { Icon } from 'ui';
import { Text, TEXT_VARIANTS } from 'ui/Typography';
import RatingScale from 'ui/RatingScale';

const Criterion = ({ criterion, ratingOptions, preview, answerId }) => {
  const [score, setScore] = useState(criterion.score);

  useEffect(() => {
    const handleSubscribe = (
      criterionAnswerId,
      criterionId,
      criterionScore,
    ) => {
      if (criterionAnswerId === answerId && criterionId === criterion.id) {
        setScore(criterionScore);
      }
    };
    global.pubsub.subscribe('grading:rating', handleSubscribe);
    return () => {
      global.pubsub.unsubscribe('grading:rating', handleSubscribe);
    };
  }, [answerId, criterion.id]);

  const setCriterionScore = criterionScore => {
    if (!preview) {
      global.pubsub.publish(
        'grading:rating',
        answerId,
        criterion.id,
        criterionScore,
      );
    }
  };

  return (
    <div>
      <div className="CriteriaList-criterion mb-8">
        <Text variant={TEXT_VARIANTS.BODY}>{criterion.name}</Text>
        <span
          className="ml-4 h-c-night"
          data-toggle="tooltip"
          title={
            criterion.description ||
            t('feedback_criteria.criterion.no_description')
          }
          data-placement="top"
        >
          <Icon name="info" />
        </span>
      </div>
      <RatingScale
        ratingOptions={ratingOptions}
        preview={preview}
        score={score}
        setScore={setCriterionScore}
        customClassName="mb-16 d-f fw-w"
      />
    </div>
  );
};

export default Criterion;
